module.exports = __webpack_public_path__ + "fonts/HelveticaNeue.2d1c965b.woff";